import { useEffect, useState } from "react";
import * as formService from '../../form-services/blocks-editor';
import { TimeBlockEditorModel } from "../../entities/time-block-editor-model";
import { BwjButtonType } from "../../../../framework/components/bwj-button";
import { BwjGrid, Row, Col } from "../../../../framework/components/bwj-layout";
import { Spacing } from "../../../../framework/components/bwj-layout/styles";
import { BwjSidePanel } from "../../../../framework/components/bwj-side-panel";
import { BwjSingleSelectField } from "../../../../framework/components/bwj-select-field/single";
import { ITimeBlockStatusOption } from "../../../../entities-generated/common/time-block-status-option";
import { IBwjFormOption } from "../../../../framework/entities/bwj-form-option";
import { IChangeTimeBlocksRequest } from "../../../../entities-generated/models/time-block/change-time-blocks-request";

interface IChangeTimeBlocksPanelProps {
  launchPanelArgs: { startBlock: number, endBlock: number } | undefined;
  onChangeTimeBlocks: (request: IChangeTimeBlocksRequest) => void;
}

const subscriberId = 'Panel.ChangeTimeBlocks';

const editorInitializer = new TimeBlockEditorModel();

export const ChangeTimeBlocksPanel: React.FunctionComponent<IChangeTimeBlocksPanelProps> = (props) => {
  const { launchPanelArgs } = props;
  const formModel = formService.useFormModel(subscriberId);
  const [showPanel, setShowPanel] = useState(false);

  useEffect(() => {
    if(!!launchPanelArgs) {
      formService.initializeService(editorInitializer);
      setShowPanel(true);
    } else {
      setShowPanel(false);
    }
  }, [launchPanelArgs]);

  const onClosePanel = () => setShowPanel(false);

  const onChangeTimeBlocks = () => {
    formService.validateAndUpdateModel()
    .then(result => {
      if(result.isValid) {
        const request = formService.toChangeRequest(launchPanelArgs!.startBlock, launchPanelArgs!.endBlock)
        props.onChangeTimeBlocks(request);
        setShowPanel(false);
      }
    });
  }

  return (
    <BwjSidePanel
      showPanel={showPanel}
      title={'Edit Selected Time Blocks'}
      footerButtons={[{
        buttonStyle: BwjButtonType.PrimaryStandard,
        text: 'Edit time blocks',
        onClick: onChangeTimeBlocks
      }, {
        buttonStyle: BwjButtonType.DefaultStandard,
        text: 'Cancel',
        onClick: onClosePanel
      }]}
      onDismiss={onClosePanel}
    >
      <BwjGrid>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={12}>
            <BwjSingleSelectField<ITimeBlockStatusOption>
              id={formService.status.id}
              required={true}
              label={formService.status.description}
              onUpdate={formService.status.onUpdate}
              input={formModel.status}
              options={formService.status.options}
              optionDisplayKey={'description'}
              optionValueKey={'id'}
            />
          </Col>
        </Row>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={12}>
            <BwjSingleSelectField<IBwjFormOption<string>>
              id={formService.isBillableTime.id}
              required={true}
              label={formService.isBillableTime.description}
              onUpdate={formService.isBillableTime.onUpdate}
              input={formModel.isBillableTime}
              options={formService.isBillableTime.options}
              optionDisplayKey={'description'}
              optionValueKey={'value'}
            />
          </Col>
        </Row>
      </BwjGrid>
    </BwjSidePanel>
  );
};